/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { CompletedUploadPart } from './CompletedUploadPart';
import {
    CompletedUploadPartFromJSON,
    CompletedUploadPartFromJSONTyped,
    CompletedUploadPartToJSON,
    instanceOfCompletedUploadPart,
} from './CompletedUploadPart';

/**
 * Completion payload for a multipart upload.
 * @export
 * @interface MultipartAssetUploadCompletion
 */
export interface MultipartAssetUploadCompletion {
    /**
     * 
     * @type {Array<CompletedUploadPart>}
     * @memberof MultipartAssetUploadCompletion
     */
    parts: Array<CompletedUploadPart>;
}


/**
 * Check if a given object implements the MultipartAssetUploadCompletion interface.
 */
export function instanceOfMultipartAssetUploadCompletion(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "parts" in value;
    return isInstance;
}

export function MultipartAssetUploadCompletionFromJSON(json: any): MultipartAssetUploadCompletion {
    return MultipartAssetUploadCompletionFromJSONTyped(json, false);
}

export function MultipartAssetUploadCompletionFromJSONTyped(json: any, ignoreDiscriminator: boolean): MultipartAssetUploadCompletion {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'parts': ((json['parts'] as Array<any>).map(CompletedUploadPartFromJSON)),
    };
}

export function MultipartAssetUploadCompletionToJSON(value?: MultipartAssetUploadCompletion | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'parts': ((value.parts as Array<any>).map(CompletedUploadPartToJSON)),
    };
}

